var _affirm_config = {
    public_api_key: "ZX7YFPMCLT27M1SS",
    script: "https://cdn1.affirm.com/js/v2/affirm.js",
    locale: "en_US",
    country_code: "USA",
};

(function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,"set");var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c="set add save post open empty reset on off trigger ready setProduct".split(" ");a<c.length;a++)f[c[a]]=l(b,d,c[a]);a=0;for(c=["get","token","url","items"];a<c.length;a++)f[c[a]]=function(){};k.async=
!0;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,_affirm_config,"affirm","checkout","ui","script","ready","jsReady");


function getCurrentPrice() {
const state = window.NolahPDPState;
if (state && typeof state.getPrice === "function") {
    return state.getPrice();
}

// Non-PDP (e.g. sale page): use data-amount from Affirm source element
const affirmEl = document.querySelector(".affirm-as-low-as[data-amount]");
if (!affirmEl) return null;

const amount = parseInt(affirmEl.getAttribute("data-amount"), 10);
return Number.isNaN(amount) ? null : amount;
}

function attachAffirmClick(el, price) {
if (!el) return;
el.style.cursor = "pointer";

const open = function (e) {
    e.preventDefault();
    e.stopPropagation();
    openAffirmModal(price);
};

el.onclick = open;
el.onkeydown = function (e) {
    if (e.key === "Enter" || e.key === " ") {
        open(e);
    }
};
}

function openAffirmModal(price) {
function doOpen() {
    if (window.affirm?.ui?.openModal) {
        affirm.ui.openModal({ amount: price });
    }
}

if (window.affirm?.ui?.ready) {
    affirm.ui.ready(doOpen);
} else {
    doOpen();
}
}

function updateCustomSpan() {
const affirmEls = document.querySelectorAll(".affirm-as-low-as");

// Non-PDP multi-card: map each Affirm estimate to its own custom text
if (affirmEls.length > 1 && !window.NolahPDPState) {
    affirmEls.forEach((affirmEl) => {
        const alaPrice = affirmEl.querySelector("span.affirm-ala-price");
        if (!alaPrice) return;

        const priceText = alaPrice.textContent.trim();
        if (!priceText) return;

        const scope = affirmEl.closest(".affirm-price-group") || affirmEl.parentElement;
        scope?.querySelectorAll(".affirm-custom-text").forEach((span) => {
            span.textContent = priceText;
        });
    });
    return;
}

const baseEl = document.querySelector(".affirm-as-low-as.AffirmEstimate--loaded span.affirm-ala-price");
if (!baseEl) return;

const priceText = baseEl.textContent.trim();
if (!priceText) return;

document.querySelectorAll(".affirm-custom-text")
    .forEach(span => (span.textContent = priceText));
}

function renderAffirm() {
const affirmEl = document.querySelector(".affirm-as-low-as");
if (!affirmEl) return;

const allAffirm = document.querySelectorAll(".affirm-as-low-as[data-amount]");

// Non-PDP multi-card: use each element's own data-amount
if (allAffirm.length > 1 && !window.NolahPDPState) {
    allAffirm.forEach((el) => {
        const price = parseInt(el.getAttribute("data-amount"), 10);
        if (!price || Number.isNaN(price)) return;

        attachAffirmClick(el, price);

        const scope = el.closest(".affirm-price-group") || el.parentElement;
        scope?.querySelectorAll(".custom-affirm-container").forEach((container) => {
            attachAffirmClick(container, price);
        });
    });

    if (window.affirm?.ui?.refresh) {
        affirm.ui.refresh();
    }

    updateCustomSpan();
    return;
}

const price = getCurrentPrice();
if (!price) return;

affirmEl.setAttribute("data-amount", price);

if (window.affirm?.ui?.refresh) {
    affirm.ui.refresh();
}

attachAffirmClick(affirmEl, price);

document.querySelectorAll(".custom-affirm-container")
    .forEach(el => attachAffirmClick(el, price));

updateCustomSpan();
}

function observeAffirmPrice() {
const targets = document.querySelectorAll(".affirm-as-low-as");

// Non-PDP multi-card: observe every Affirm source
if (targets.length > 1 && !window.NolahPDPState) {
    targets.forEach((target) => {
        const observer = new MutationObserver(updateCustomSpan);
        observer.observe(target, { childList: true, subtree: true, characterData: true });
    });
    return;
}

const target = document.querySelector(".affirm-as-low-as.AffirmEstimate--loaded");
if (!target) return;

const observer = new MutationObserver(updateCustomSpan);
observer.observe(target, { childList: true, subtree: true, characterData: true });
}

document.addEventListener("DOMContentLoaded", () => {
renderAffirm();
observeAffirmPrice();

setTimeout(() => {
    renderAffirm();
    updateCustomSpan();
}, 300);
});

document.addEventListener("state:option-changed", () => {
renderAffirm();
setTimeout(updateCustomSpan, 200);
});
